import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { createDynamicLink } from 'src/services/napi/dynamicLinks/createDynamicLink';
import { DynamicLink } from 'src/services/napi/dynamicLinks/interfaces/dynamicLink.interface';
import {
  CreateDynamicLinkMutationFnParams,
  UseCreateDynamicLinkMutationParams
} from './interfaces/useCreateDynamicLinkMutation.interface';

const createDynamicLinkMutationFn = async ({
  requestBody
}: CreateDynamicLinkMutationFnParams): Promise<DynamicLink | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);
  const { _id: projectId } = currentProject ?? {};

  if (!projectId) return;

  const response = await createDynamicLink({ projectId, requestBody });
  return response?.dynamicLinkDetails;
};

export const useCreateDynamicLinkMutation = ({
  onError,
  onSuccess
}: UseCreateDynamicLinkMutationParams) => {
  const { notify } = useNotification();

  return useMutation({
    mutationFn: (data: CreateDynamicLinkMutationFnParams) => createDynamicLinkMutationFn(data),
    onError: () => {
      notify({ message: 'Error Creating Dynamic Link... Try again later', severity: 'error' });
      onError?.();
    },
    onSuccess: () => {
      notify({ message: 'Dynamic Link Created Successfully' });
      onSuccess?.();
    }
  });
};
